
import React from 'react'
import teacher from './svgs/teacherGray.svg'
import { BaseIcon } from './_base'

export const TeacherIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={teacher} {...{fontSize,size,...sx}} />
    )
}
